import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductSearchPage, ProductSearchService, TranslationService, TranslatePipe } from '@spartacus/core';
import { PageLayoutService, ProductListComponentService, ViewConfig, ViewModes, SortingComponent, PaginationComponent } from '@spartacus/storefront';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { ProductViewModeService } from './../../services/product-view-mode-service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { Router } from '@angular/router';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { KnBrActiveFacetComponent } from '../kn-br-active-facet/kn-br-active-facet.component';
import { KnBrProductGridItemComponent } from './kn-br-product-grid-item/kn-br-product-grid-item.component';
import { KnBrProductListItemComponent } from './kn-br-product-list-item/kn-br-product-list-item.component';
import { KnBrProductScrollComponent } from './kn-br-product-scroll/kn-br-product-scroll.component';

@Component({
    selector: 'kn-br-product-list',
    templateUrl: './kn-br-product-list.component.html',
    styleUrls: ['./kn-br-product-list.component.scss'],
    imports: [SortingComponent, KnBrActiveFacetComponent, PaginationComponent, KnBrProductGridItemComponent, KnBrProductListItemComponent, KnBrProductScrollComponent, AsyncPipe, TranslatePipe]
})
export class KnBrProductListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  isInfiniteScroll: boolean;
  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;
  viewMode$ = this.viewModeService.getViewMode$();
  ViewModes = ViewModes;
  knBrProductService: any;
  
  constructor(
    protected pageLayoutService: PageLayoutService,
    protected productListComponentService: ProductListComponentService,
    public scrollConfig: ViewConfig,
    protected viewModeService: ProductViewModeService,
    protected productSearchService: ProductSearchService,
    private knBrCommonService: KnBrCommonService,
    protected router: Router,
    protected translationService: TranslationService
  ) {
    if(router.url.includes('/search/')){
      this.knBrCommonService.setSpinner(true);
    }
  }
  ngOnInit(): void {
    this.isInfiniteScroll = this.scrollConfig.view.infiniteScroll.active;
    // this.isInfiniteScroll = true;
    this.viewModeService.setViewMode(ViewModes.Grid);
    this.model$.subscribe(() => this.knBrCommonService.setSpinner(false));
  }

    getLabels(sorts: any[]): {} {
    const labels = {};
    sorts.forEach((sort) => (labels[sort.code] = sort.code));
    return labels;
  }

  

  getPageTitle(model: any) {
    return combineLatest([
      this.translationService.translate('knBrMessages.plpListMsg', {
        records: model.pagination.currentPage + 1 === model.pagination.totalPages ? model.pagination.totalResults : model.pagination.totalResults > model.pagination.pageSize ? model.pagination.pageSize * (model.pagination.currentPage + 1) : model.pagination.totalResults,
        total: model.pagination.totalResults,
      }),
    ]).pipe(
      map(([textTitle]) => {
        // this.ngTitle.setTitle(textTitle);
        return textTitle;
      })
    );
  }

  sortList(sortCode: string): void {    
    this.productListComponentService.sort(sortCode);
  }
   setViewMode(mode: string): void {
      this.knBrCommonService.setSpinner(true);
      this.knBrProductService.setSelectedProducts([]);
      const newMode = mode === ViewModes.Grid ? ViewModes.List : ViewModes.Grid;
      this.viewModeService.setViewMode(newMode);
    }

  ngOnDestroy(): void {
    this.productSearchService.getResults();
    this.productSearchService.clearResults();
    this.subscription.unsubscribe();
  }
}
